import React, { useEffect, useState } from "react";
import Styles from "./assets/Sidebar.module.css";
import Logo from "../assets/logo/logo.png";
import SidebarItems from "./SidebarItems";
import axiosInstance from "../axiosInterceptor";
import { toast } from "react-toastify";

export default function Sidebar() {
  const [profileData, setProfileData] = useState(null);

  useEffect(() => {
    axiosInstance
      .get("admin/getProfile")
      .then((response) => {
        if (response.data.isSuccess) {
          setProfileData(response.data?.profile?.pages);
        } else {
          toast.error(response.data.error);
        }
      })
      .catch((error) => {
        toast.error("Something went wrong. Please try again!!");
      });
  }, []);

  return (
    <>
      <div className={`${Styles.sidebar} bg-white`}>
        <div className={`${Styles.border} text-center p-1 `}>
          <img src={Logo} alt="DoubtQ" className="p-2" />
        </div>
        <li className="border-top list-unstyled" />
        <ul className={`${Styles.menu} col-12 p-3`}>
          {profileData?.map((item) => {
            if (
              item.pageName &&
              item.allocatedActions.some((action) => action.status === true)
            ) {
              if (item.pageName === "Master Tables") {
                const masterTableSubmenus = item.allocatedActions
                  .filter((action) => action.status === true)
                  .map((action) => action.actionType);

                if (masterTableSubmenus.length > 0) {
                  return (
                    <SidebarItems
                      key={item.pageId}
                      submenu={masterTableSubmenus}
                    >
                      {item.pageName}
                    </SidebarItems>
                  );
                }
                return null;
              }
              const subMenuItems = item.allocatedActions
                .filter(
                  (submenu) =>
                    submenu.status === true && submenu.actionType !== "List",
                )
                .map((submenu) => submenu.actionType);

              return (
                <SidebarItems
                  key={item.pageId}
                  submenu={subMenuItems.length > 0 ? subMenuItems : null}
                >
                  {item.pageName}
                </SidebarItems>
              );
            }

            return null;
          })}
        </ul>
      </div>
    </>
  );
}
